import React, { FC, useState } from 'react'
import { ConfirmDeleteModal } from './ConfirmDeleteModal'
import { DaxUsagesResponse } from 'tabs/data/api/generated'
import { CButton } from '../CButton'
import { RelatedResourcesModal } from '../RelatedResourcesModal'

const DEFAULT_BUTTON_LABLE = 'Delete'

type DeleteDataProps = {
  disabled?: boolean
  buttonLabel?: string
  title?: string
  subtitle?: string
  onDelete: (forceDelete: boolean) => Promise<DaxUsagesResponse>
  updateCallback?: () => Promise<void>
}

export const DeleteData: FC<DeleteDataProps> = ({
  title,
  subtitle,
  disabled,
  buttonLabel = DEFAULT_BUTTON_LABLE,
  onDelete,
  updateCallback,
}) => {
  const [open, setOpen] = useState(false)
  const [usage, setUsage] = useState<null | DaxUsagesResponse['usages']>(null)

  const handleOpenConfirmModal = () => {
    setOpen(true)
  }

  const handleCloseConfirmModal = () => {
    setOpen(false)
    setUsage(null)
  }

  const handleDelete = async () => {
    await onDelete(false).then(
      r => r,
      async error => {
        if (error?.response) {
          const errorData = await error.response.json()

          if (errorData?.usages) setUsage(errorData?.usages)
          throw error
        }
      },
    )

    if (updateCallback) await updateCallback()
  }

  const handleForceDelete = async () => {
    await onDelete(true)

    if (updateCallback) await updateCallback()
  }

  return (
    <>
      <CButton disabled={disabled} label={buttonLabel} color="danger" onClick={handleOpenConfirmModal} />

      {usage ? (
        <RelatedResourcesModal
          open={open}
          data={usage}
          submitLabel="Delete Anyway"
          onClose={handleCloseConfirmModal}
          onSubmit={handleForceDelete}
        />
      ) : (
        <ConfirmDeleteModal
          open={open}
          title={title}
          subtitle={subtitle}
          onClose={handleCloseConfirmModal}
          onDelete={handleDelete}
        />
      )}
    </>
  )
}
